import { FeedType } from './types';

/** Prefix for every testid on the page — see `okf/admin/e2e.md` § 12. */
export const ADAPTERS_BASE_ID = 'admin-adapters';

/**
 * RBAC module `GMSAdapter` — the backend spells it `@check_rbac("GMSAdapter", "read" | "update")`,
 * the frontend key is the module lowercased plus the action (CLAUDE.md, *RBAC naming*).
 * `read` shows the sidebar item and the page; `update` additionally shows the Edit button.
 */
export const ADAPTERS_READ_PERMISSION = 'gmsadapter_read';
export const ADAPTERS_UPDATE_PERMISSION = 'gmsadapter_update';

export const ADAPTERS_PATH = '/admin/adapters';

/**
 * The six feed tabs, in the same order as Data Import › Connectors. Ids are the backend's
 * `feed_type` values (Midway's dispatch keys — `orders`, never `invoice`; `prices`, never `price`).
 */
export const FEED_TABS: ReadonlyArray<{ id: FeedType; label: string }> = [
  { id: 'products', label: 'Products' },
  { id: 'orders', label: 'Orders' },
  { id: 'prices', label: 'Price' },
  { id: 'availability', label: 'Availability' },
  { id: 'relatedproducts', label: 'Related Products' },
  { id: 'substitutes', label: 'Substitutes' },
];

export const feedLabel = (feedType: FeedType): string =>
  FEED_TABS.find((tab) => tab.id === feedType)?.label ?? feedType;

/** Every user-facing string, so the ticket's exact copy is pinned in one place. */
export const ADAPTERS_COPY = {
  title: 'Adapters',
  edit: 'Edit',
  cancel: 'Cancel',
  save: 'Save',
  unsaved: 'Unsaved changes',
  addParty: 'Add party',
  noParties: 'No parties assigned yet',
  savedToast: 'Adapter party assignments updated.',
  discardedToast: 'Changes discarded. Party assignments are back to the last saved state.',
  saveFailedToast: 'Could not save adapter assignments',
  loadFailedTitle: 'Could not load adapters',
  retry: 'Retry',
  footnoteView: 'Every add, remove and save is recorded in the Admin Activity Log.',
  footnoteEdit: 'A party can be assigned to only one adapter per feed. Changes on every tab save together.',
  emptyTitle: (label: string) => `No adapters convert the ${label} feed yet.`,
  emptyDescription: 'Adapters are added by engineering in the backend and appear here once available.',
  footer: (adapterCount: number, label: string, assigned: number, total: number) =>
    `${adapterCount} ${adapterCount === 1 ? 'adapter' : 'adapters'} for ${label} · ${assigned} of ${total} parties assigned across all feeds`,
} as const;
